import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { CheckboxGroupField } from "~/components/form/checkbox-group-field";

import {
  UserAndCoachPersonalitySchema,
  coachPersonalityField,
  personalityStep,
  userPersonalityField,
} from "~/lib/schemas/coach-discovery";

import type { UserAndCoachPersonalityForm } from "~/lib/schemas/coach-discovery";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import { createNoIndexMeta } from "~/lib/shared/meta";

export const Route = createFileRoute("/_public/discovery/steps/6/")({
  head: () =>
    createNoIndexMeta(
      "Step 6: Personality Preferences – Dream Coach Match",
      "Define your and your coach's personality preferences in our discovery process",
    ),
  component: DiscoveryStep6,
});

function DiscoveryStep6() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm(
    UserAndCoachPersonalitySchema,
    6,
  );
  const { handleSubmit, formState, control } = form;
  const { errors, isSubmitting, isValid } = formState;

  const onSubmit = (_data: UserAndCoachPersonalityForm) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={personalityStep.title} />
      <DiscoveryStep.SubTitle title={personalityStep.subTitle} />

      <DiscoveryStep.Card className="mt-6">
        <FormField
          labelSize="xl"
          error={errors.userPersonality?.message}
          label={userPersonalityField.subTitle}
        >
          <CheckboxGroupField
            name="userPersonality"
            control={control}
            options={userPersonalityField.options || []}
            exclusiveOptions={["Skip this question"]}
            maxSelections={2}
          />
        </FormField>
      </DiscoveryStep.Card>

      <DiscoveryStep.Card className="mt-6">
        <FormField
          labelSize="xl"
          error={errors.coachPersonality?.message}
          label={coachPersonalityField.subTitle}
        >
          <CheckboxGroupField
            name="coachPersonality"
            control={control}
            options={coachPersonalityField.options || []}
            exclusiveOptions={["Skip this question"]}
            maxSelections={2}
          />
        </FormField>
      </DiscoveryStep.Card>

      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        loading={isSubmitting}
        disabled={!isValid}
      />
    </form>
  );
}
